import { TrackTraceItem } from './trackTraceItem'

export class TrackTraceItemArray {
    showItem: boolean;
    items: Array<Array<TrackTraceItem>> = new Array<Array<TrackTraceItem>>();

}